import { datadogRum } from '@datadog/browser-rum';

import type {
  ErrorContext,
  LogContext,
  Logger,
  LoggerConfig,
} from 'src/utils/logger/logger';

const loadDatadogRUM = ({
  buildVersion,
  sessionTrackingEnabled,
  environment,
  country,
}: DatadogLoggerConfig) => {
  datadogRum.init({
    applicationId: 'f40b7e7b-185f-44ae-a13c-15d57daa7812',
    clientToken: 'pube1d4717722eaecac18893ab040fb5ffb',
    site: 'datadoghq.com',
    service: 'user-management-ui',
    version: `${buildVersion}-country-${country}`,
    env: environment,
    sessionSampleRate: sessionTrackingEnabled ? 100 : 0,
    sessionReplaySampleRate: 100,
    silentMultipleInit: true,
    trackUserInteractions: false,
    defaultPrivacyLevel: 'mask-user-input',
  });

  datadogRum.startSessionReplayRecording();
};

interface DatadogLoggerConfig extends LoggerConfig {
  sessionTrackingEnabled?: boolean;
}

const createDatadogLogger = ({
  buildVersion,
  sessionTrackingEnabled = true,
  environment,
  hirerAccountId,
  userId,
  country,
}: DatadogLoggerConfig): Logger => {
  loadDatadogRUM({
    environment,
    sessionTrackingEnabled,
    buildVersion,
    hirerAccountId,
    userId,
    country,
  });
  datadogRum.setGlobalContextProperty('sessionContext', {
    hirerAccountId,
    userId,
    'user-country': country,
  });

  return Object.freeze({
    info: (message: string, context: LogContext | undefined) =>
      datadogRum.addAction(context?.activity ?? message, {
        ...context,
        message,
      }),
    error: (message: string, context: ErrorContext | undefined) => {
      const error = context?.error ?? new Error(message);
      datadogRum.addError(error, {
        ...context,
        message,
      });
    },
  });
};

export { createDatadogLogger };
